import { ApolloClient, createHttpLink, InMemoryCache } from '@apollo/client/core';
import { setContext } from 'apollo-link-context';
import { onError } from 'apollo-link-error';
import { createUploadLink } from 'apollo-upload-client';

export const AUTH_TOKEN = 'tms-admin-apollo-token';

// Http endpoint
const uri = process.env.VUE_APP_GRAPHQL_HTTP || '__VUE_APP_GRAPHQL_HTTP__';
// Files URL root
export const filesRoot = process.env.VUE_APP_FILES_ROOT || uri.substr(0, uri.indexOf('/graphql'));

// Vue.prototype.$filesRoot = filesRoot;

// Disabled until further research
const globalErrorLink = onError(({ graphQLErrors, networkError }) => {
  if (graphQLErrors) {
    console.log('invoke from custom link');
    graphQLErrors.forEach((detail) => {
      console.log(detail);
      console.log(
        `[GraphQL error]: Message: ${detail.message}, Location: ${detail.locations}, Path: ${detail.path}`,
      );
    });
  }

  if (networkError) console.log(`[Network error]: ${networkError}`);
});

// Create Cache
// More information visit
// https://www.apollographql.com/docs/react/caching/cache-configuration/
const cache = new InMemoryCache();

// Config
const defaultOptions = {
  cache,
  uri,
  // You can use `wss` for secure connection (recommended in production)
  // Use `null` to disable subscriptions
  wsEndpoint: null,
  // LocalStorage token
  tokenName: AUTH_TOKEN,
  // Enable Automatic Query persisting with Apollo Engine
  persisting: false,
  // Use websockets for everything (no HTTP)
  // You need to pass a `wsEndpoint` for this to work
  websocketsOnly: false,
  // Is being rendered on the server?
  ssr: false,
  // link: ApolloLink.from([
  //   // globalErrorLink,
  // ]),
  defaultHttpLink: true,
  errorHandler(error: any) {
    console.log('Global error handler');
    console.error(error);
  },
};

function defaultGetAuth(tokenName: string) {
  if (typeof window !== 'undefined') {
    // get the authentication token from local storage if it exists
    const token = window.localStorage.getItem(tokenName);
    // return the headers to the context so httpLink can read them
    return token ? `Bearer ${token}` : '';
  }
  return '';
}

// HTTP Auth header injection
const authLink = setContext(async (_, { headers }) => {
  const Authorization = await defaultGetAuth(AUTH_TOKEN);
  const authorizationHeader = Authorization ? { Authorization } : {};
  return {
    headers: {
      ...headers,
      ...authorizationHeader,
    },
  };
});

// TODO: Find ways to handle auth expired

export function createClient(options = {}) {
  // Form HTTP LINK from uri (.env or default uri)
  const httpLink = createUploadLink({
    uri,
  });

  // Concat all the http link parts
  const link = authLink.concat(httpLink as any);

  // Create apollo client
  const apolloClient = new ApolloClient({
    link: link as any,
    ...defaultOptions,
    ...options,
  });

  return apolloClient;
}

export const client = createClient();

export const unauthorizeClient = createClient({
  link: createHttpLink({ uri }),
});

// Manually call this when user log in
export async function onLogin(apolloClient: any, token: any) {
  if (typeof localStorage !== 'undefined' && token) {
    localStorage.setItem(AUTH_TOKEN, token);
  }
  // if (apolloClient.wsClient) restartWebsockets(apolloClient.wsClient);
  try {
    await apolloClient.resetStore();
  } catch (e: any) {
    // eslint-disable-next-line no-console
    console.log('%cError on cache reset (login)', 'color: orange;', e.message);
  }
}

// Manually call this when user log out
export async function onLogout(apolloClient: any) {
  if (typeof localStorage !== 'undefined') {
    localStorage.removeItem(AUTH_TOKEN);
  }
  // if (apolloClient.wsClient) restartWebsockets(apolloClient.wsClient);
  try {
    await apolloClient.resetStore();
  } catch (e: any) {
    // eslint-disable-next-line no-console
    console.log('%cError on cache reset (logout)', 'color: orange;', e.message);
  }
}
